import React, { Component } from 'react';

class ComboMenuProcesos extends Component {

    render() {
        const { 
            infoData, 
            nombreAction, 
            selectCombo, 
            selecciones, 
            placeholder, 
            titulo, 
            wide, 
            id, 
            takePlaceholderValue, 
            valorActualCombos, 
            administradoraIdSeleccionada, 
            valorActualCombosProcesos,
            mostrarTablero
        } = this.props
        
        let black = false,procesosFiltrados = infoData;
        let firstOption = {Id:0,Descripcion: placeholder == "Todos" ? placeholder : takePlaceholderValue ? placeholder : "Seleccione " + placeholder }        
        let tipoProceso = selecciones.esEjecucionDemanda ? selecciones?.tipoProcesoEjecucion == '0' ? null : selecciones?.tipoProcesoEjecucion 
                                                        : selecciones?.tipoProceso && selecciones?.tipoProceso != '0' ? selecciones?.tipoProceso : null;

        if (selecciones[nombreAction] == firstOption.Id) black = true

        if(nombreAction == "proceso" || (nombreAction == "procesoEjecucion" && tipoProceso)){
            procesosFiltrados = infoData && infoData.length > 0 ? infoData.filter(x=> x.TipoProceso ? x.TipoProceso : x.Tipo_Proceso == tipoProceso) : [];

            if (nombreAction == "procesoEjecucion" && administradoraIdSeleccionada && administradoraIdSeleccionada != '-1' && administradoraIdSeleccionada != '0') {
                procesosFiltrados = procesosFiltrados?.filter(x=> x.Administradora_Id == administradoraIdSeleccionada)
            }
        }

        return (
            <div>
                <div className='labelComboProcesos'>{titulo}</div>
                <select id={id} className={"selectComboProcesos " + (wide ? 'wideCombo' : '') + (mostrarTablero ? "" : " botonMenuProcesos--disabled")} style={black ? { color: "black" } : null} value={selecciones[nombreAction]} onChange={(event) => {
                    const index = event.target.selectedIndex;
                    const value = event.target.options[index].value;
                    valorActualCombos ? selectCombo(nombreAction, value, valorActualCombos.administradoraId, valorActualCombos.tipoProceso) : valorActualCombosProcesos && nombreAction == "procesoEjecucion" ? selectCombo(nombreAction, value, valorActualCombosProcesos.administradoraId, valorActualCombosProcesos.tipoProceso) : selectCombo(nombreAction, value)
                }}>
                    <option key={firstOption.Id} value={firstOption.Id}>{firstOption.Descripcion}</option>
                    {(nombreAction == "marcaId" || nombreAction == "marcaIdEjecucion") && <option key={-1} value={-1}>Ninguna</option>}
                    {procesosFiltrados.length > 0 && procesosFiltrados.map((item, index) => { return <option style={{ color: "black" }} key={index} value={item.Id}>{item.Descripcion ? item.Descripcion : item.DescripcionProceso}</option> })}
                </select>
            </div>
        );
    }
}

export default ComboMenuProcesos;